import _ from 'underscore';
import {
  jsdataRawDataPlugin as commonJsdataRawDataPlugin,
} from '@bingads-webui/projection-grid-js-data-raw-data';

export const jsdataRawDataPlugin = commonJsdataRawDataPlugin({
  getRawData: _.property('raw'),
});
